import { render } from "./Form1.vue?vue&type=template&id=9ca37420&scoped=true"
import script from "./Form1.vue?vue&type=script&lang=js"
export * from "./Form1.vue?vue&type=script&lang=js"

import "./Form1.vue?vue&type=style&index=0&id=9ca37420&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca37420"]])

export default __exports__